import { PageConfig } from "../page-configs";
import { AlertId, getAlert } from "../alert";
import { DISCLAIMER } from "../../../global/variables";
import { getWelcomeText } from "../welcome";
import { SAS_BUTTONS } from "../../feature-buttons";

export const pageConfigSAS: PageConfig = {
    header: "Digitaler Assistent",
    alert: getAlert(AlertId.QuestionsAboutAusbildungOrStudium),
    welcome: {
        text: getWelcomeText("SAS"),
        disclaimer: DISCLAIMER,
        buttons: SAS_BUTTONS,
    },
};
